import { Fingerprint, FingerprintConfig } from './Fingerprint';

let fingerprintInstance: Fingerprint | undefined = undefined;

const handler = {
  get: (_target: unknown, objectKey: any) => {
    return fingerprintInstance?.[objectKey as keyof Fingerprint];
  },
};

export const fingerprintInit = async (config: FingerprintConfig) => {
  fingerprintInstance = new Fingerprint(config);
  await fingerprintInstance.init();
  return fingerprintInstance;
};

export const fingerprint = new Proxy({}, handler) as Fingerprint;
